import { Fragment } from 'react';
import { useMyLinks } from 'shared/hooks/useMyLinks';
import MainProfile from './MainProfile/MainProfile';
import PublicProfileLinks from './PublicProfileLinks/PublicProfileLinks';
import MeLoadingSkeleton from './Skeletons/MeLoadingSkeleton/MeLoadingSkeleton';

const MyLinks = () => {
  const { talentInfo, meLoading, preferences, changeSlug, changeActiveLink } = useMyLinks();

  if (meLoading) return <MeLoadingSkeleton />;

  return (
    <Fragment>
      <MainProfile talentInfo={talentInfo} preferences={preferences} changeActiveLink={changeActiveLink} />
      <PublicProfileLinks talentInfo={talentInfo} changeSlug={changeSlug} />
    </Fragment>
  );
};

export default MyLinks;
